export enum ProductUsageEnum {
  LANDSCAPE = 'LANDSCAPE',
  SPORT = 'SPORT',
  WILDLIFE = 'WILDLIFE',
  VIDEO = 'VIDEO',
  STREET = 'STREET',
  PORTRAIT = 'PORTRAIT',
  REPORTAGE = 'REPORTAGE',
  TRAVEL = 'TRAVEL',
  MACRO = 'MACRO',
  STARS = 'STARS',
  MOON = 'MOON',
  STUDIO = 'STUDIO',
  ASTRO = 'ASTRO',
}